import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "@/store/store";
import {
  type LodgeAISlice,
  type LodgeAIAutomation,
  type LodgeAISession,
  type LodgeAIQueue,
  LodgeAIModalType,
} from "./types/lodgeAITypes";

const initialState: LodgeAISlice = {
  modalType: undefined,
  isOpen: false,
  automation: undefined,
  queue: undefined,
  session: undefined,
};

export const lodgeAISlice = createSlice({
  name: "lodgeAI",
  initialState,
  reducers: {
    openLodgeAIModal: (state, action: PayloadAction<Required<Pick<LodgeAISlice, "modalType">>>) => {
      return {
        ...state,
        isOpen: true,
        modalType: action.payload.modalType,
      };
    },
    closeLodgeAIModal: (state) => {
      return {
        ...state,
        isOpen: false,
        modalType: undefined,
      };
    },
    setLodgeAIQueue: (state, action: PayloadAction<LodgeAIQueue>) => {
      return {
        ...state,
        queue: {
          ...state.queue,
          ...action.payload,
        },
      };
    },
    resetLodgeAIQueue: (state) => {
      return {
        ...state,
        queue: undefined,
      };
    },
    setLodgeAIAutomation: (state, action: PayloadAction<LodgeAIAutomation>) => {
      return {
        ...state,
        automation: {
          ...state.automation,
          ...action.payload,
        },
      };
    },
    setLodgeAISession: (state, action: PayloadAction<LodgeAISession>) => {
      return {
        ...state,
        session: {
          ...state.session,
          ...action.payload,
        },
      };
    },
    setLodgeAIError: (state, action: PayloadAction<LodgeAISlice["error"]>) => {
      return {
        ...state,
        isOpen: true,
        modalType: LodgeAIModalType.Error,
        error: {
          ...state.error,
          ...action.payload,
        },
      };
    },
    resetLodgeAI: () => {
      return initialState;
    },
  },
});

export const {
  openLodgeAIModal,
  closeLodgeAIModal,
  setLodgeAIQueue,
  resetLodgeAIQueue,
  setLodgeAIAutomation,
  setLodgeAISession,
  setLodgeAIError,
  resetLodgeAI,
} = lodgeAISlice.actions;

export const lodgeAISelector = (state: RootState) => {
  return state.lodgeAI;
};
export const lodgeAIQueueSelector = (state: RootState) => {
  return state.lodgeAI.queue;
};
export const lodgeAIAutomationSelector = (state: RootState) => {
  return state.lodgeAI.automation;
};
export const lodgeAISessionSelector = (state: RootState) => {
  return state.lodgeAI.session;
};
export const lodgeAIErrorSelector = (state: RootState) => {
  return state.lodgeAI.error;
};

export default lodgeAISlice.reducer;
